import { RuleParamSchema } from "vee-validate/dist/types/types";
import { isUndefinedOrNullOrEmptyString } from "@/module/Validation/rules/isUndefinedOrNullOrEmptyString";

const validate = async (
  value: any,
  { country }: Record<string, any>,
): Promise<boolean> => {
  if (isUndefinedOrNullOrEmptyString(value)) {
    return false;
  }

  country = country.toUpperCase().split("-")[0];

  if (Array.isArray(value)) {
    return value.length > 0 && value.every((val) => validate(val, { country }));
  }

  value = String(value);

  if (value === "") {
    return false;
  }

  const { parsePhoneNumberFromString } = await import(
    /* webpackChunkName: "libphonenumber" */
    "libphonenumber-js/max"
  );

  const phoneNumber = parsePhoneNumberFromString(value, country);
  return phoneNumber !== undefined && phoneNumber.isValid();
};

const params: RuleParamSchema[] = [
  {
    name: "country",
  },
];

export { validate, params };

export default {
  validate,
  params,
};
